<li class="m-carousel-item" :class="{ 'm--no-animation': animNotReady }" :style="{transform : translate, left: margin + 'px', right: margin + 'px'}">
    <slot></slot>
</li>
